import commonConstant from '../../common/_commonConstant';
import { sumParkingTime, sumFreeParkingTime, timeIn } from '../../helpers';

export const totalPaymentAmount = createPayment => {
  try {
    return createPayment.paymentTotalParkingFeeAmount ? createPayment.paymentTotalParkingFeeAmount : null;
  } catch (error) {
    return null;
  }
};

export const totalParkingMinutes = createPayment => {
  try {
    return createPayment.paymentTotalParkingMinutes ?
      (createPayment.paymentTotalParkingMinutes - createPayment.paymentTotalRedemptionMinutes - createPayment.paymentTotalBuildingFreeParkingMinutes)
      : null;
  } catch (error) {
    return null;
  }
};

export const totalFeeMinutes = createPayment => {
  try {
    return createPayment.paymentTotalParkingFeeMinutes ? createPayment.paymentTotalParkingFeeMinutes : null;
  } catch (error) {
    return null;
  }
};

export const carOut = (createPayment, getParkingStatus) => {
  try {
    return new Date(new Date(timeIn(getParkingStatus)).setMinutes(
      new Date(timeIn(getParkingStatus)).getMinutes() +
      sumParkingTime(getParkingStatus) +
      createPayment.paymentTotalParkingFeeMinutes +
      createPayment.paymentTotalBuildingFreeParkingMinutes +
      (createPayment.paymentTotalRedemptionMinutes > 0 ? createPayment.paymentTotalRedemptionMinutes - sumFreeParkingTime(getParkingStatus) : createPayment.paymentTotalRedemptionMinutes),
    ));
  } catch (error) {
    return null;
  }
};

export const qrCode = createPayment => {
  try {
    return createPayment.metadata.payment.qrCode ? createPayment.metadata.payment.qrCode : null;
  } catch (error) {
    return null;
  }
};

export const statusPaid = getPaymentDetail => {
  try {
    return getPaymentDetail.paymentStatus === commonConstant.paymentStatusPaid ? true : false;
  } catch (error) {
    return false;
  }
};

export const statusReady = getPaymentDetail => {
  try {
    return getPaymentDetail.paymentStatus === commonConstant.paymentStatusReady ? true : false;
  } catch (error) {
    return false;
  }
};

export const errorMessage = getPaymentDetail => {
  try {
    return getPaymentDetail.gatewayErrorReason.message ? getPaymentDetail.gatewayErrorReason.message : null;
  } catch (error) {
    return null;
  }
};

export const paymentRefNo = data => {
  try {
    return data.paymentRefNo ? data.paymentRefNo : null;
  } catch (error) {
    return null;
  }
};

export const createPaymentTotalAmount = createPayment => {
  try {
    if (
      (createPayment.paymentTotalParkingFeeAmount || createPayment.paymentTotalParkingFeeAmount === 0) &&
      (createPayment.paymentTotalOvernightFeeAmount || createPayment.paymentTotalOvernightFeeAmount === 0)
    ) {
      return (createPayment.paymentTotalParkingFeeAmount + createPayment.paymentTotalOvernightFeeAmount).toLocaleString();
    } else if (createPayment.paymentTotalParkingFeeAmount || createPayment.paymentTotalParkingFeeAmount === 0) {
      return (createPayment.currentPayment.paymentTotalParkingFeeAmount).toLocaleString();
    } else if (createPayment.paymentTotalOvernightFeeAmount || createPayment.paymentTotalOvernightFeeAmount === 0) {
      return (createPayment.paymentTotalOvernightFeeAmount).toLocaleString();
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const paymentKioskParkingGateLocation = data => {
  try {
    const location = data.paymentLocation.split('-');
    return data.paymentLocation ? `${location[location.length - 2]}_${location[location.length - 1]}` : null;
  } catch (error) {
    return null;
  }
};
